import { deleteApi, getApi, patchApi, postApi } from '../../utils/api'

export function getLabels(params) {
  return getApi({
    endpoint: `api/label/`,
    params,
  })
}

export function createLabel(data) {
  return postApi({ data, endpoint: `api/label/` })
}

export function getLabel(id) {
  return getApi({
    endpoint: `api/label/${id}/`,
  })
}

export function updateLabel(id, data) {
  return patchApi({
    data,
    endpoint: `api/label/${id}/`,
  })
}

export function deleteLabel(id) {
  return deleteApi({ endpoint: `api/label/${id}/` })
}
